<div class="day-of-week-edit__container">
  @if (dayOfWeek) {
    <div class="day-label">
      {{ dayDisplayNameKey(dayOfWeek) | translate }}
    </div>
  }
  <glxy-form-field bottomSpacing="small">
    <mat-slide-toggle [checked]="!closed" (change)="toggleChanged()" [color]="'primary'">
      @if (closed) {
        {{ 'FRONTEND.FORMS.HOURS_OF_OPERATION.CLOSED' | translate }}
      } @else {
        {{ 'FRONTEND.FORMS.HOURS_OF_OPERATION.OPEN' | translate }}
      }
    </mat-slide-toggle>
  </glxy-form-field>
  @if (!closed) {
    <glxy-form-field [bottomSpacing]="'none'">
      <mat-checkbox class="time-span__checkbox" [(ngModel)]="allDay"
        >{{ 'FRONTEND.FORMS.HOURS_OF_OPERATION.OPEN_24_HOURS' | translate }}
      </mat-checkbox>
    </glxy-form-field>

    @if (!allDay) {
      <forms-hoo-time-span
        *ngFor="let span of value || [{}]; let i = index"
        [value]="span"
        (valueChange)="valueChanged($event, i)"
        [allowDelete]="value.length > 1"
        (delete)="delete(i)"
      ></forms-hoo-time-span>
      @if (hoursOverlap) {
        <glxy-error>{{ 'FRONTEND.FORMS.HOURS_OF_OPERATION.HOURS_OVERLAP' | translate }}</glxy-error>
      }

      <div class="day-of-week-edit__add-hours-button">
        <button mat-stroked-button (click)="addHours()">
          <mat-icon>add</mat-icon>
          {{ 'FRONTEND.FORMS.HOURS_OF_OPERATION.ADD_HOURS' | translate }}
        </button>
      </div>
    }
  }
</div>
